<!-- Put the tooltip on the containing div so that it can show when the button is disabled-->
<div [ngbTooltip]="i18n.dgTagRating_ShareTag" placement="bottom">
  <button
    class="skill-signal-share-button"
    df-button
    df-button-square
    dfButtonType="passive"
    (click)="copySkillSignalUrl()"
    data-dgat="skill-signal-share-button-427"
  >
    <df-icon
      icon="arrow-forward"
      a11yText="i18n.dgTagRating_ShareTag"
    ></df-icon>
  </button>
</div>
